"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.CompetitorOfferSource = exports.DebtSwapTradelinesRequiringBalanceTransferStatus = exports.hasHomePurchaseTerms = exports.isLoanTermsForCryptoProduct = exports.FirstLienRefiUpfrontDrawAprsComputationStrategy = exports.LIEN_RELATED_FULL_LINE_CONTINGENCY_TYPES = exports.FullCreditLineContingencyType = exports.OfferContingencyStatus = exports.LIEN_RELATED_OFFER_CONTINGENCIES = exports.OfferContingency = exports.UpfrontCashOutAmountCalculationMethod = exports.resolveUpfrontFeeExpectingAtMostOneFee = exports.resolveUpfrontFee = exports.UpfrontFeeType = exports.PythonFullReUnderwritingOfferType = exports.COUNTER_OFFER_APR_REDUCTION = exports.PRIME_V3_PRODUCT_CATEGORIES = exports.AUTOPAY_DISABLED_CASHBACK_ELIGIBLE_PRODUCT_CATEGORY = exports.ProductCategory = exports.OfferConstraintReason = void 0;
const interestRate_1 = require("../interestRate");
var OfferConstraintReason;
(function (OfferConstraintReason) {
    OfferConstraintReason["CLTV"] = "CLTV";
    OfferConstraintReason["DTI"] = "DTI";
    OfferConstraintReason["FICO"] = "FICO";
    OfferConstraintReason["OTHER"] = "OTHER";
})(OfferConstraintReason || (exports.OfferConstraintReason = OfferConstraintReason = {}));
// Must match corresponding enum in aven_python/src/avenTypes/productCategory.py
/* @TranslateToPython @TranslateToEnum */
var ProductCategory;
(function (ProductCategory) {
    ProductCategory["basic"] = "basic";
    ProductCategory["prime"] = "prime";
    ProductCategory["primeV2"] = "primeV2";
    ProductCategory["primeV3"] = "primeV3";
    ProductCategory["autoPayOptInCashBackPromo"] = "autoPayOptInCashBackPromo";
    ProductCategory["autoPayDisabledCashBack"] = "autoPayDisabledCashBack";
    ProductCategory["primeV2AutoPayDisabledCashBack"] = "primeV2AutoPayDisabledCashBack";
    ProductCategory["primeV3AutoPayDisabledCashBack"] = "primeV3AutoPayDisabledCashBack";
    ProductCategory["fixedTerm"] = "fixedTerm";
    ProductCategory["fixedTermAutoPayDisabledCashBack"] = "fixedTermAutoPayDisabledCashBack";
})(ProductCategory || (exports.ProductCategory = ProductCategory = {}));
/* @TranslateToPython @TranslateToEnum */
exports.AUTOPAY_DISABLED_CASHBACK_ELIGIBLE_PRODUCT_CATEGORY = [
    ProductCategory.autoPayDisabledCashBack,
    ProductCategory.primeV2AutoPayDisabledCashBack,
    ProductCategory.primeV3AutoPayDisabledCashBack,
    ProductCategory.fixedTermAutoPayDisabledCashBack,
];
exports.PRIME_V3_PRODUCT_CATEGORIES = [ProductCategory.primeV3, ProductCategory.primeV3AutoPayDisabledCashBack];
// Counter offer APR reduction constant (50 basis points)
exports.COUNTER_OFFER_APR_REDUCTION = new interestRate_1.InterestRateDiscount({ units: interestRate_1.InterestRateUnits.percent, aprAsPercent: 0.5 });
var PythonFullReUnderwritingOfferType;
(function (PythonFullReUnderwritingOfferType) {
    PythonFullReUnderwritingOfferType["CREDIT_LINE_INCREASE"] = "CREDIT_LINE_INCREASE";
    PythonFullReUnderwritingOfferType["APR_REDUCTION"] = "APR_REDUCTION";
    PythonFullReUnderwritingOfferType["FULL_BALANCE_SWEEP"] = "FULL_BALANCE_SWEEP";
})(PythonFullReUnderwritingOfferType || (exports.PythonFullReUnderwritingOfferType = PythonFullReUnderwritingOfferType = {}));
/**
 * Which upfront fee an offer charges. origination = % of line size (e.g. TX §50(a)(6)(E)); firstDraw =
 * % of the first draw ("transfer fee"); none = no upfront fee. Resolved on the backend from the offer's
 * own fee fields so consumers branch on the type rather than inferring it from a raw amount or product
 * flag.
 * @TranslateToPython
 */
var UpfrontFeeType;
(function (UpfrontFeeType) {
    UpfrontFeeType["origination"] = "origination";
    UpfrontFeeType["firstDraw"] = "firstDraw";
    UpfrontFeeType["none"] = "none";
})(UpfrontFeeType || (exports.UpfrontFeeType = UpfrontFeeType = {}));
const resolveUpfrontFee = ({ originationFeePercent, firstDrawFeePercent }) => {
    if ((originationFeePercent ?? 0) > 0) {
        return { type: UpfrontFeeType.origination, percent: originationFeePercent ?? 0 };
    }
    if ((firstDrawFeePercent ?? 0) > 0) {
        return { type: UpfrontFeeType.firstDraw, percent: firstDrawFeePercent ?? 0 };
    }
    return { type: UpfrontFeeType.none, percent: 0 };
};
exports.resolveUpfrontFee = resolveUpfrontFee;
const resolveUpfrontFeeExpectingAtMostOneFee = ({ originationFeePercent, firstDrawFeePercent, }) => {
    const origination = originationFeePercent ?? 0;
    const firstDraw = firstDrawFeePercent ?? 0;
    if (origination > 0 && firstDraw > 0) {
        throw new Error(`resolveUpfrontFeeExpectingAtMostOneFee: offer has both an origination fee (${origination}) and a first-draw fee (${firstDraw}); exactly one is expected`);
    }
    return (0, exports.resolveUpfrontFee)({ originationFeePercent, firstDrawFeePercent });
};
exports.resolveUpfrontFeeExpectingAtMostOneFee = resolveUpfrontFeeExpectingAtMostOneFee;
/**
 * Method used to calculate the cash out amount for fixed-term upfront offers.
 * @TranslateToPython
 */
var UpfrontCashOutAmountCalculationMethod;
(function (UpfrontCashOutAmountCalculationMethod) {
    /**
     * Cash out is calculated as a percentage of the line size using MIN_LINE_DRAW_DOWN_FOR_ACTIVATION.
     * e.g., 80% upfront draw means cashOut = lineSize * 0.8
     */
    UpfrontCashOutAmountCalculationMethod["PercentageOfLineSize"] = "PercentageOfLineSize";
    /**
     * Line size is calculated from a specific cash out dollar amount (e.g., stated usage).
     * The line size is computed so that after fees, the net cash out equals this amount.
     * Note: The actual cash out may differ if constrained by DTI, FCF, or other line size limits.
     */
    UpfrontCashOutAmountCalculationMethod["SpecificAmount"] = "SpecificAmount";
    /**
     * No upfront cash out requirement (e.g., revolving-only products).
     */
    UpfrontCashOutAmountCalculationMethod["NoUpfrontCashOut"] = "NoUpfrontCashOut";
})(UpfrontCashOutAmountCalculationMethod || (exports.UpfrontCashOutAmountCalculationMethod = UpfrontCashOutAmountCalculationMethod = {}));
/* @TranslateToPython @TranslateToEnum */
var OfferContingency;
(function (OfferContingency) {
    OfferContingency["titleInsurance"] = "titleInsurance";
    OfferContingency["employmentVerification"] = "employmentVerification";
    OfferContingency["employmentDurationVerification"] = "employmentDurationVerification";
    OfferContingency["hazardInsurance"] = "hazardInsurance";
    OfferContingency["illinoisAntiPredatory"] = "illinoisAntiPredatory";
    OfferContingency["mlsListing"] = "mlsListing";
    OfferContingency["deceasedCoOwner"] = "deceasedCoOwner";
    OfferContingency["removedCoOwner"] = "removedCoOwner";
    OfferContingency["removedSeparatedSpouse"] = "removedSeparatedSpouse";
    OfferContingency["removedMarriedSpouse"] = "removedMarriedSpouse";
    OfferContingency["poaApplicantNameReview"] = "poaApplicantNameReview";
    OfferContingency["priorLienRelease"] = "priorLienRelease";
    OfferContingency["lienPositionVerification"] = "lienPositionVerification";
    OfferContingency["userProvidedFirstLienVerification"] = "userProvidedFirstLienVerification";
    OfferContingency["userProvidedAllLienInfoVerification"] = "userProvidedAllLienInfoVerification";
    OfferContingency["uccFlowComplete"] = "uccFlowComplete";
    OfferContingency["uccIdentityChecks"] = "uccIdentityChecks";
    OfferContingency["appraisalContingency"] = "appraisalContingency";
    OfferContingency["trustVerification"] = "trustVerification";
    OfferContingency["naturalDisasterVideoAndLocation"] = "naturalDisasterVideoAndLocation";
    /** Cardholder must balance transfer specified tradelines in order to activate their account. */
    OfferContingency["debtSwapBalanceTransferableTradelinesV1"] = "debtSwapBalanceTransferableTradelinesV1";
})(OfferContingency || (exports.OfferContingency = OfferContingency = {}));
/** Offer contingencies that block fund access pending lien-related verification. */
exports.LIEN_RELATED_OFFER_CONTINGENCIES = new Set([
    OfferContingency.priorLienRelease,
    OfferContingency.lienPositionVerification,
    OfferContingency.userProvidedFirstLienVerification,
    OfferContingency.userProvidedAllLienInfoVerification,
]);
/** @TranslateToPython @TranslateToEnum */
var OfferContingencyStatus;
(function (OfferContingencyStatus) {
    OfferContingencyStatus["notApplicable"] = "notApplicable";
    OfferContingencyStatus["pending"] = "pending";
    OfferContingencyStatus["succeeded"] = "succeeded";
    OfferContingencyStatus["failed"] = "failed";
    OfferContingencyStatus["manualReview"] = "manualReview";
    OfferContingencyStatus["pendingCustomerAction"] = "pendingCustomerAction";
})(OfferContingencyStatus || (exports.OfferContingencyStatus = OfferContingencyStatus = {}));
/* @TranslateToPython @TranslateToEnum */
var FullCreditLineContingencyType;
(function (FullCreditLineContingencyType) {
    FullCreditLineContingencyType["passAvenLienPositionHardCut"] = "passAvenLienPositionHardCut";
    FullCreditLineContingencyType["passPaymentPerformanceHardCut"] = "passPaymentPerformanceHardCut";
    FullCreditLineContingencyType["passUccIncomeVerification"] = "passUccIncomeVerification";
})(FullCreditLineContingencyType || (exports.FullCreditLineContingencyType = FullCreditLineContingencyType = {}));
/** Full-line-size contingencies that block fund access pending lien-related verification. */
exports.LIEN_RELATED_FULL_LINE_CONTINGENCY_TYPES = new Set([FullCreditLineContingencyType.passAvenLienPositionHardCut]);
var FirstLienRefiUpfrontDrawAprsComputationStrategy;
(function (FirstLienRefiUpfrontDrawAprsComputationStrategy) {
    /**
     * @deprecated Renamed to INTACT_REFI_FIRST_LIEN_AT_ATTESTED_APR_SOLVING_FOR_CASH_OUT_APR.
     * Retained for legacy persisted/replayed first-lien-refi offers written before the rename.
     * Leading underscore discourages new usage.
     */
    FirstLienRefiUpfrontDrawAprsComputationStrategy["_SUM_OF_MONTHLY_PAYMENTS"] = "SUM_OF_MONTHLY_PAYMENTS";
    /**
     * @deprecated Renamed to BOTH_APRS_AT_TARGET_APR_FROM_POLICY.
     * Retained for legacy persisted/replayed first-lien-refi offers written before the rename.
     * Leading underscore discourages new usage.
     */
    FirstLienRefiUpfrontDrawAprsComputationStrategy["_USE_BLENDED_APR"] = "USE_BLENDED_APR";
    FirstLienRefiUpfrontDrawAprsComputationStrategy["INTACT_REFI_FIRST_LIEN_AT_ATTESTED_APR_SOLVING_FOR_CASH_OUT_APR"] = "INTACT_REFI_FIRST_LIEN_AT_ATTESTED_APR_SOLVING_FOR_CASH_OUT_APR";
    FirstLienRefiUpfrontDrawAprsComputationStrategy["BOTH_APRS_AT_TARGET_APR_FROM_POLICY"] = "BOTH_APRS_AT_TARGET_APR_FROM_POLICY";
})(FirstLienRefiUpfrontDrawAprsComputationStrategy || (exports.FirstLienRefiUpfrontDrawAprsComputationStrategy = FirstLienRefiUpfrontDrawAprsComputationStrategy = {}));
const isLoanTermsForCryptoProduct = (loanTerms) => {
    return 'cryptoOltvBps' in loanTerms;
};
exports.isLoanTermsForCryptoProduct = isLoanTermsForCryptoProduct;
// homePurchaseTerms lives only on HomeLoanTerms within the LoanTerms union (keyof over a union keeps
// only shared keys), so the `in` check is what crosses to the HomeLoanTerms variant. Shared by the
// purchase pre-qual/pre-approval letters and the FLP pre-qual page so all read the field the same way.
const hasHomePurchaseTerms = (loanTerms) => {
    return 'homePurchaseTerms' in loanTerms && Boolean(loanTerms.homePurchaseTerms);
};
exports.hasHomePurchaseTerms = hasHomePurchaseTerms;
var DebtSwapTradelinesRequiringBalanceTransferStatus;
(function (DebtSwapTradelinesRequiringBalanceTransferStatus) {
    DebtSwapTradelinesRequiringBalanceTransferStatus["pending"] = "pending";
    DebtSwapTradelinesRequiringBalanceTransferStatus["inProgress"] = "inProgress";
    DebtSwapTradelinesRequiringBalanceTransferStatus["complete"] = "complete";
    DebtSwapTradelinesRequiringBalanceTransferStatus["canceled"] = "canceled";
})(DebtSwapTradelinesRequiringBalanceTransferStatus || (exports.DebtSwapTradelinesRequiringBalanceTransferStatus = DebtSwapTradelinesRequiringBalanceTransferStatus = {}));
var CompetitorOfferSource;
(function (CompetitorOfferSource) {
    CompetitorOfferSource["selfAttested"] = "selfAttested";
    CompetitorOfferSource["avenReviewed"] = "avenReviewed";
    CompetitorOfferSource["skipped"] = "skipped";
})(CompetitorOfferSource || (exports.CompetitorOfferSource = CompetitorOfferSource = {}));
